export default __webpack_public_path__ + "static/media/Strip02.03898bd9.png";